import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { audiencesApi } from '../../../api/audiences';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/base/Notifications';
import Snapshot from '../../../components/ui/Buttons/Snapshot';
import ListConfirmationModal from '../../../components/ui/modals/ListConfirmationModal';
import SaveSnapshotModal from '../../../components/ui/modals/SaveSnapshotModal';

const ProfileSnapshot = ({ segment, number }) => {
  const { id } = useParams();
  const [showSnapshotModal, setShowSnapshotModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [snapshotName, setSnapshotName] = useState('');
  const [snapshotSegment, snapshotSegmentResult] =
    audiencesApi.useSnapshotSegmentsMutation();
  const [snapshotDraftSegment, snapshotDraftSegmentResult] =
    audiencesApi.useSaveCustomListFromSegmentDraftMutation();

  useEffect(() => {
    if (snapshotDraftSegmentResult.isSuccess) {
      showSuccessMessage('Segment was successfully saved as List');
      setShowSnapshotModal(false);
      snapshotDraftSegmentResult.reset();
    }
    if (snapshotDraftSegmentResult.isError) {
      showErrorMessage(
        snapshotDraftSegmentResult?.error?.data?.error?.message ||
          'Something went wrong'
      );
      setShowSnapshotModal(false);
      snapshotDraftSegmentResult.reset();
    }
  }, [snapshotDraftSegmentResult]);

  useEffect(() => {
    if (snapshotSegmentResult.isSuccess) {
      showSuccessMessage('Segment was successfully saved as List');
      setShowSnapshotModal(false);
      snapshotSegmentResult.reset();
    }
    if (snapshotSegmentResult.isError) {
      showErrorMessage(
        snapshotSegmentResult?.error?.data?.message || 'Something went wrong'
      );
      setShowSnapshotModal(false);
      snapshotSegmentResult.reset();
    }
  }, [snapshotSegmentResult]);

  const handleSnapshotClick = () => {
    if (number >= 50000) {
      setShowConfirmationModal(true);
    } else {
      setShowSnapshotModal(true);
    }
  };

  return (
    <>
      <Snapshot
        tooltip="Save snapshot as List"
        onClick={handleSnapshotClick}
        number={number}
      />
      {showSnapshotModal && (
        <SaveSnapshotModal
          value={snapshotName}
          setValue={setSnapshotName}
          onSubmit={() => {
            try {
              if (id) {
                snapshotSegment({ id, name: snapshotName });
              } else {
                snapshotDraftSegment({ ...segment, name: snapshotName });
              }
            } catch (err) {
              showErrorMessage(err);
            }
          }}
          onCancel={() => setShowSnapshotModal(false)}
          loading={
            snapshotSegmentResult.isLoading ||
            snapshotSegmentResult.isFetching ||
            snapshotDraftSegmentResult.isLoading ||
            snapshotDraftSegmentResult.isFetching
          }
        />
      )}
      {showConfirmationModal && (
        <ListConfirmationModal
          number={number}
          onSubmit={() => {
            setShowConfirmationModal(false);
            setShowSnapshotModal(true);
          }}
          onCancel={() => setShowConfirmationModal(false)}
        />
      )}
    </>
  );
};

export default ProfileSnapshot;
